import { useParams } from 'react-router'
import { ROUTE_CUSTOMERS } from '@klear/constants'
import { CustomerWizard } from '@klear/customer-ui/customer-wizard'
import { useCustomer } from '@klear/customer-ui/use-customers'
import { useTrader } from '@klear/ui/hooks/use-trader'
import { useReturnUrlExit } from '@klear/ui/wizard/return-url'
import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'
import toInteger from 'lodash/toInteger'

export type CustomerWizardPageMode = 'create' | 'view'

export interface CustomerWizardPageProps {
  mode: CustomerWizardPageMode
}

export default function CustomerWizardPage({ mode }: CustomerWizardPageProps) {
  const { traderId, customerId } = useParams()
  const { urlPrefixApp } = useTrader(traderId)

  const tid = toInteger(traderId)
  const id = customerId ? toInteger(customerId) : 0
  const base = `${urlPrefixApp}/${ROUTE_CUSTOMERS}`
  const { customer } = useCustomer(id, { enabled: mode !== 'create', traderId: tid })
  useDocumentTitle(customer?.name, mode === 'create' ? 'New Customer' : 'Customer')

  const { exit, exitAfterSave } = useReturnUrlExit(base)

  return (
    <CustomerWizard
      mode={mode}
      customerId={mode !== 'create' ? id : undefined}
      traderId={tid}
      showTraderSelect={false}
      showIdentifiers
      showParentOrganization={false}
      showCompanyLookup={false}
      canEdit={mode === 'create'}
      canViewCustomerCreditRatings={false}
      canEditCustomerCreditRatings={false}
      onBack={exit}
      onDone={() => exitAfterSave()}
    />
  )
}
